// extracted by mini-css-extract-plugin
export default {"control":"ArmySlideButton_control__3+a6V","viewport":"ArmySlideButton_viewport__MciWU"};